import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Abbreviations,
  CertificationTracking,
  ConsentManagement,
  CookieManagement,
  DiagramsandLogos,
  FAQ,
  MainReference,
  ReferenceDocFormat,
  StandardComparison,
  StatutoryReporting,
  WebsiteTracking,
} from "../pages/ReferenceDoc";
import PageNotFound from "../components/View/PageNotFound";
import { Wrapper } from "../utils/RolesandAccess";

function ReferenceDocRoutes() {
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {

    if (location.pathname === `/standard/${stdId}/reference-doc/`||location.pathname === `/standard/${stdId}/reference-doc`) {
      navigate(`/standard/${stdId}/reference-doc/reference-doc-format`, { replace: true });
    }
  }, [location.pathname, stdId, navigate]);
  return (
    <Routes>
    <Route path="/" element={<Wrapper accessKey={stdId} Component={MainReference} />}>
      <Route path="reference-doc-format" element={<Wrapper accessKey={stdId} Component={ReferenceDocFormat} />} />
      <Route path="website-tracking" element={<Wrapper accessKey={stdId} Component={WebsiteTracking} />} />
      <Route path="consent-management" element={<Wrapper accessKey={stdId} Component={ConsentManagement} />} />
      <Route
        path="certification-tracking"
        element={<Wrapper accessKey={stdId} Component={CertificationTracking} />}
      />
      <Route path="statutory-reporting" element={<Wrapper accessKey={stdId} Component={StatutoryReporting}/>} />
      <Route path="cookie-management" element={<Wrapper accessKey={stdId} Component={CookieManagement}/>} />
      <Route path="glossary-faq" element={<Wrapper accessKey={stdId} Component={Abbreviations}/>} />
      <Route path="ie-audit-reports" element={<Wrapper accessKey={stdId} Component={FAQ}/>} />
      <Route path="standard-comparison" element={<Wrapper accessKey={stdId} Component={StandardComparison}/>} />
      <Route path="diagramsandlogos" element={<Wrapper accessKey={stdId} Component={DiagramsandLogos}/>} />
    </Route>
    <Route path="/*" element={<PageNotFound/>} />
    </Routes>
  );
}

export default ReferenceDocRoutes;
